<template>
    <div
        class="cart-item"
        :class="{
            'cart-item--sold': !item.inStock && !ignoreStockCount && $device.isDesktop && !item.is_always_available,
        }">
        <component
            :is="disableLink ? 'div' : 'nuxt-link'"
            :to="item.link + '/'"
            @click.native="isShowCart = false"
            class="cart-item__img">
            <template v-if="item.img">
                <img data-not-lazy v-if="staticImg" v-lazy-load :data-src="item.img" alt="" />
                <UiImage
                    v-else
                    :path="item.img"
                    :desktop="{ height: 240, width: 160 }"
                    :mobile="{ height: 168, width: 112 }"
                    :lazy="false" />
            </template>
            <span
                v-if="
                    ((!item.inStock && !ignoreStockCount) || item.is_soldout) &&
                    $device.isDesktop &&
                    !item.is_always_available
                "
                class="cart-item__sold text_9"
                >{{ $t("sold_out") }}</span
            >
        </component>
        <div class="cart-item__data">
            <div
                v-if="item.drop && keyedDrops[item.drop.slug]"
                v-html="keyedDrops[item.drop.slug].text"
                class="text_9"></div>
            <div class="cart-item__row cart-item__header">
                <DropLine :invalidDropsPromo="invalidDropsPromo" v-if="item.drop" :drop="item.drop" fromCart />
            </div>
            <div class="cart-item__row cart-item__header">
                <div class="cart-item__col">
                    <div class="cart-item__art color-text_2">
                        {{ item.art }}
                    </div>
                </div>
                <div class="cart-item__col" v-if="allowChange">
                    <div
                        class="cart-item__remove"
                        :class="{
                            'color-text_2': allowChange,
                            'color-text_1': !allowChange,
                        }"
                        @click="
                            removeItem(item.key);
                            setOrder();
                        ">
                        {{ $t("del") }}
                    </div>
                </div>
            </div>
            <div class="cart-item__row">
                <div class="cart-item__col">
                    <component
                        :is="disableLink ? 'div' : 'nuxt-link'"
                        :to="item.link + '/'"
                        @click.native="$emit('update:isShowCart', false)"
                        class="cart-item__name"
                        >{{ item.name }}
                    </component>
                </div>
                <div class="cart-item__col cart-item__col--price" v-if="$device.isDesktop">
                    <div class="cart-item__full-price text_11 color-text_3" v-if="item.price != item.fullPrice">
                        {{ item.fullPrice.toLocaleString("ru-RU") }}
                        <span class="money">{{ currency }}</span>
                    </div>
                    <div class="cart-item__price">
                        {{ itemPrice.toLocaleString("ru-RU") }}
                        <span class="money">{{ currency }}</span>
                    </div>
                </div>
            </div>
            <div class="cart-item__row">
                <div class="cart-item__col">
                    <div
                        v-if="item.color"
                        class="cart-item__color"
                        :class="{
                            'color-text_2': allowChange,
                            'color-text_1': !allowChange,
                        }">
                        <CrystalIcon :color="item.color.code" :secondary-color="item.color.secondary_code" />
                        {{ item.color.name }}
                    </div>
                </div>
                <div class="cart-item__col" v-if="item.discount && $device.isDesktop">
                    <div class="cart-item__full-price">
                        {{ item.fullPrice }}
                    </div>
                </div>
            </div>
            <div class="cart-item__row" v-if="!$device.isDesktop">
                <div class="cart-item__col cart-item__col--price">
                    <div class="cart-item__full-price text_11 color-text_2" v-if="item.price != item.fullPrice">
                        {{ item.fullPrice.toLocaleString("ru-RU") }}
                        <span class="money">{{ currency }}</span>
                    </div>
                    <div class="cart-item__price text_11">
                        {{ itemPrice.toLocaleString("ru-RU") }}
                        <span class="money">{{ currency }}</span>
                    </div>
                </div>
                <div class="cart-item__col" v-if="item.discount">
                    <div class="cart-item__full-price">
                        {{ item.fullPrice }}
                    </div>
                </div>
            </div>
            <div class="cart-item__footer">
                <div class="cart-item__row">
                    <div class="cart-item__col">
                        <div
                            v-if="item.size"
                            class="cart-item__size"
                            @click="
                                item.sizes.length > 1 && allowChange
                                    ? $emit('update:editedItem', {
                                          key: item.key,
                                          type: 'size',
                                      })
                                    : ''
                            ">
                            <span
                                class=""
                                :class="{
                                    'color-text_2': allowChange,
                                    'color-text_1': !allowChange,
                                }"
                                >{{ $t("size") }}:</span
                            >
                            <span>{{ item.size }}</span>
                            <transition name="fade">
                                <div
                                    class="size-change"
                                    v-if="allowChange && editedItem.key == item.key && editedItem.type == 'size'"
                                    v-click-outside="
                                        () => {
                                            $emit('update:editedItem', {
                                                key: '',
                                                type: '',
                                            });
                                        }
                                    ">
                                    <div
                                        class="size-change__item"
                                        :class="{
                                            'size-change__item--active': item.size == size.name,
                                        }"
                                        v-for="size in item.sizes.filter((el) => el.in_stock)"
                                        :key="size.size_id"
                                        @click="
                                            changeCartItem(item.key, 'size', {
                                                sizeName: size.name,
                                                sizeId: size.size_id,
                                                id: size.sku_id,
                                            })
                                        ">
                                        {{ size.name }}
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div
                            class="cart-item__count"
                            @click="
                                allowChange
                                    ? $emit('update:editedItem', {
                                          key: item.key,
                                          type: 'count',
                                      })
                                    : ''
                            ">
                            <span
                                class=""
                                :class="{
                                    'color-text_2': allowChange,
                                    'color-text_1': !allowChange,
                                }"
                                :style="`color:${
                                    editedItem
                                        ? editedItem.key == item.key && editedItem.type == 'count'
                                            ? '#0000'
                                            : allowChange
                                            ? '#7b7b7b'
                                            : '#000'
                                        : '#000'
                                }`"
                                v-if="$device.isDesktop || !allowChange"
                                >{{ $t("qnt") }}:</span
                            >
                            <div
                                class="count-change__button"
                                :class="{
                                    'count-change__button--disabled': item.count == 1,
                                }"
                                @click="changeCartItem(item.key, 'count', item.count == 1 ? item.count : --item.count)"
                                v-if="!$device.isDesktop && allowChange">
                                <svg-icon name="minus" width="8" height="8" />
                            </div>
                            <span>{{ item.count }}</span>
                            <div
                                class="count-change__button"
                                :class="{
                                    'count-change__button--disabled': item.count >= item.inStock,
                                }"
                                @click="
                                    changeCartItem(
                                        item.key,
                                        'count',
                                        item.count >= item.inStock ? item.inStock : ++item.count,
                                        item.inStock
                                    )
                                "
                                v-if="!$device.isDesktop && allowChange">
                                <svg-icon name="plus" width="8" height="8" />
                            </div>
                            <transition name="fade">
                                <div
                                    class="count-change"
                                    v-if="
                                        allowChange &&
                                        editedItem.key == item.key &&
                                        editedItem.type == 'count' &&
                                        $device.isDesktop
                                    "
                                    v-click-outside="
                                        () => {
                                            $emit('update:editedItem', {
                                                key: '',
                                                type: '',
                                            });
                                        }
                                    ">
                                    <div
                                        class="count-change__button"
                                        :class="{
                                            'count-change__button--disabled': item.count == 1,
                                        }"
                                        @click="
                                            changeCartItem(
                                                item.key,
                                                'count',
                                                item.count == 1 ? item.count : --item.count
                                            )
                                        ">
                                        <svg-icon name="minus" width="8" height="8" />
                                    </div>
                                    <div class="count-change__value">
                                        {{ item.count }}
                                    </div>
                                    <div
                                        class="count-change__button"
                                        :class="{
                                            'count-change__button--disabled': item.count >= item.inStock,
                                        }"
                                        @click="
                                            changeCartItem(
                                                item.key,
                                                'count',
                                                item.count >= item.inStock ? item.inStock : ++item.count,
                                                item.inStock
                                            )
                                        ">
                                        <svg-icon name="plus" width="8" height="8" />
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div
                        class="cart-item__col"
                        :class="{
                            'color-text_2': allowChange,
                            'color-text_1': !allowChange,
                        }"
                        v-if="allowChange">
                        <WishlistHeart :itemId="item.id" :itemSlug="item.link.split('/')[2]" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WishlistHeart from "~/components/WishlistHeart";
import DropLine from "@/components/DropLine";
import { mapGetters, mapState, mapActions } from "vuex";
import CrystalIcon from "./CrystalIcon.vue";
import UiImage from "./ui/Image.vue";

export default {
    name: "CartItem",
    components: { UiImage, CrystalIcon, WishlistHeart, DropLine },
    props: [
        "item",
        "allowChange",
        "editedItem",
        "orderItems",
        "ignoreStockCount",
        "invalidDropsPromo",
        "disableLink",
        "staticImg",
    ],
    computed: {
        ...mapGetters({
            currency: "globalvars/getCurrency",
            currencyCode: "globalvars/getCurrencyCode",
        }),
        ...mapState("order", ["promoData"]),
        ...mapState("collections", ["keyedDrops"]),

        itemPrice() {
            if (this.promoData && this.promoData.prices[this.item.id]) {
                return this.promoData.prices[this.item.id].discounted_price;
            }
            return this.item.price;
        },
    },
    methods: {
        ...mapActions({
            addItemToDb: "order/addItemToDb",
            deleteItemFromDb: "order/deleteItemFromDb",
            setOrder: "order/setOrder",
        }),
        removeItem(key) {
            this.$grom.reachEcommerce("remove", {
                products: [
                    {
                        name: this.item.name, // Название товара
                        id: this.item.id.toString(), // Идентификатор товара
                        price: this.item.discount_price
                            ? this.item.discount_price.toFixed(2)
                            : this.item.price.toFixed(2), // Стоимость товара
                        brand: "post-post-scriptum", // Название бренда
                        category: this.item.category, // Название категории
                        variant: `${this.item.size} ${this.item.color.name}`, // Размер, цвет
                        list: this.item.collection,
                        quantity: this.item.count, // Количество товаров, удаленных из корзины (без 'кавычек')
                    },
                ],
            }); // Яндекс.Метрика: удаление из корзины
            this.$gtm.push({
                event: "removeFromCart",
                ecommerce: {
                    remove: {
                        products: [
                            {
                                name: this.item.name, // Название товара
                                id: this.item.id.toString(), // Идентификатор товара
                                price: this.item.discount_price
                                    ? this.item.discount_price.toFixed(2)
                                    : this.item.price.toFixed(2), // Стоимость товара
                                brand: "post-post-scriptum", // Название бренда
                                category: this.item.category, // Название категории
                                variant: `${this.item.size} ${this.item.color.name}`, // Размер, цвет
                                list: this.item.collection,
                                quantity: this.item.count, // Количество товаров, удаленных из корзины (без 'кавычек')
                            },
                        ],
                    },
                },
            });
            window.$sendRetailCRMEvent("cart", {
                cart_id: "",
                items: [
                    {
                        external_id: this.item.id.toString(),
                        price: this.item.discount_price ? this.item.discount_price : this.item.price,
                        quantity: this.item.count,
                    },
                ],
            });

            this.deleteItemFromDb(key);
        },
        changeCartItem(key, operation, value, inStock = 0) {
            let item = {
                key: key,
                id: this.orderItems[key].id,
                slug: this.orderItems[key].slug,
                sizeId: this.orderItems[key].sizeId,
                sizeName: this.orderItems[key].sizeName,
                count: this.orderItems[key].count,
            };
            if (operation == "count") {
                if (item.count < value) {
                    this.$grom.reachEcommerce("add", {
                        products: [
                            {
                                name: this.item.name, // Название товара
                                id: this.item.id.toString(), // Идентификатор товара
                                price: this.item.discount_price
                                    ? this.item.discount_price.toFixed(2)
                                    : this.item.price.toFixed(2), // Стоимость товара
                                brand: "post-post-scriptum", // Название бренда
                                category: this.item.category, // Название категории
                                variant: `${this.item.size} ${this.item.color.name}`, // Размер, цвет
                                list: this.item.collection,
                                quantity: 1, // Количество товаров, удаленных из корзины (без 'кавычек')
                            },
                        ],
                    }); // Яндекс.Метрика: добавление в корзину
                    this.$gtm.push({
                        event: "addToCart",
                        ecommerce: {
                            currencyCode: this.currencyCode,
                            add: {
                                products: [
                                    {
                                        name: this.item.name, // Название товара
                                        id: this.item.id.toString(), // Идентификатор товара
                                        price: this.item.discount_price
                                            ? this.item.discount_price.toFixed(2)
                                            : this.item.price.toFixed(2), // Стоимость товара
                                        brand: "post-post-scriptum", // Название бренда
                                        category: this.item.category, // Название категории
                                        variant: `${this.item.size} ${this.item.color.name}`, // Размер, цвет
                                        list: this.item.collection,
                                        quantity: 1, // Количество товаров, удаленных из корзины (без 'кавычек')
                                    },
                                ],
                            },
                        },
                    });
                }
                if (item.count > value && window.dataLayer) {
                    this.$grom.reachEcommerce("remove", {
                        products: [
                            {
                                name: this.item.name, // Название товара
                                id: this.item.id.toString(), // Идентификатор товара
                                price: this.item.discount_price
                                    ? this.item.discount_price.toFixed(2)
                                    : this.item.price.toFixed(2), // Стоимость товара
                                brand: "post-post-scriptum", // Название бренда
                                category: this.item.category, // Название категории
                                variant: `${this.item.size} ${this.item.color.name}`, // Размер, цвет
                                list: this.item.collection,
                                quantity: 1, // Количество товаров, удаленных из корзины (без 'кавычек')
                            },
                        ],
                    }); // Яндекс.Метрика: уменьшение количества
                    window.dataLayer.push({
                        event: "removeFromCart",
                        ecommerce: {
                            remove: {
                                products: [
                                    {
                                        name: this.item.name, // Название товара
                                        id: this.item.id.toString(), // Идентификатор товара
                                        price: this.item.discount_price
                                            ? this.item.discount_price.toFixed(2)
                                            : this.item.price.toFixed(2), // Стоимость товара
                                        brand: "post-post-scriptum", // Название бренда
                                        category: this.item.category, // Название категории
                                        variant: `${this.item.size} ${this.item.color.name}`, // Размер, цвет
                                        list: this.item.collection,
                                        quantity: 1, // Количество товаров, удаленных из корзины (без 'кавычек')
                                    },
                                ],
                            },
                        },
                    });
                }

                if (inStock == value) {
                    this.$emit("showCountRestriction");
                }
                if (item.count == value) return;
                item.count = value;
                this.addItemToDb(item);
                this.setOrder();
            }

            if (operation == "size") {
                if (item.sizeId == value.sizeId) return;
                this.deleteItemFromDb(key);

                item.sizeId = value.sizeId;
                item.sizeName = value.sizeName;
                item.id = value.id;
                item.key = value.id;

                let existItem = this.$store.getters["order/getLiveItemById"](value.id);

                if (existItem) {
                    item.slug = existItem.slug;
                    let existItem_count = this.$store.getters["order/getItem"](value.id).count;
                    item.count += existItem_count;
                    if (item.count > existItem.in_stock) {
                        item.count = existItem.in_stock;
                    }
                    this.addItemToDb(item);
                    this.setOrder();
                } else {
                    this.$axios
                        .get(this.$store.getters["globalvars/getHost"] + "api/skus?id[]=" + item.id)
                        .then((res) => {
                            if (res.data) {
                                let newItem = res.data[0];
                                item.slug = newItem.slug;
                                if (item.count > newItem.in_stock) {
                                    item.count = newItem.in_stock;
                                }
                                this.addItemToDb(item);
                                this.setOrder();
                            }
                        });
                }
                setTimeout(() => {
                    this.$emit("update:editedItem", { key: "", type: "" });
                }, 10);
            }
        },
    },
};
</script>
<style lang="less">
.cart-item {
    display: flex;

    &--sold {
        .cart-item__data {
            opacity: 0.4;
        }
    }

    & + & {
        margin-top: 32px;
    }

    &__header {
        margin-bottom: 12px;
        @media @sm {
            margin-bottom: 4px;
        }
    }

    &__footer {
        margin-top: auto;

        svg {
            display: block;
        }
    }

    &__sold {
        position: absolute;
        bottom: 16px;
        right: 16px;
        padding: 4px 8px;
        color: #000;
        border: 1px solid;
    }

    &__img {
        width: 160px;
        margin-right: 16px;
        position: relative;
        padding-top: 240px;
        .lazyLoad {
            opacity: 1 !important;
        }
        @media @sm {
            padding-top: 168px;
        }

        img {
            position: absolute;
            top: 0;
            left: 0;
        }

        @media @sm {
            width: 112px;
            flex-shrink: 0;
        }

        .cart-item--sold &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(to bottom right, #0000 calc(50% - 1px), #ac82f1 50%, #0000 calc(50% + 1px));
            z-index: 1;
            pointer-events: none;
        }
    }

    &__data {
        // padding-top: 10px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        @media @sm {
            padding-top: 0;
        }
    }

    &__row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .cart-item__footer & {
            align-items: center;
        }

        & + & {
            margin-top: 4px;
        }
    }

    &__count {
        position: relative;
        @media @sm {
            display: flex;
        }

        .editable & {
            cursor: pointer;

            &:hover {
                span {
                    color: @accent;
                }
            }

            span {
                .trs(color);
            }
        }

        span {
            @media @sm {
                margin: 0 8px;
                display: inline-block;
                vertical-align: middle;
                .blocked & {
                    margin: 0;
                }
            }
        }

        @media @sm {
            margin-left: 24px;
        }
    }

    &__size {
        margin-right: 16px;
        position: relative;

        .editable & {
            cursor: pointer;

            &:hover {
                span {
                    + span {
                        color: @accent;
                    }
                }
            }

            span {
                .trs(color);
            }
        }

        span + span {
            min-width: 16px;
            display: inline-block;

            .blocked & {
                color: #000;
            }
        }
    }

    &__color {
        display: flex;
        align-items: center;
        gap: 10px;

        svg {
            margin-right: 6px;
            display: block;
            position: relative;
            top: -1px;
        }

        span[style*="color: rgb(255"],
        span[style*="fff"] {
            svg {
                stroke: #000;
                stroke-width: 0.5px;
            }
        }
    }

    &__remove {
        cursor: pointer;
        .trs(opacity);

        &:hover {
            opacity: 0.5;
        }
    }

    &__col {
        display: flex;
        align-items: flex-end;

        &--price {
            flex-direction: column;
            @media @sm {
                flex-direction: row-reverse;
                align-items: baseline;
            }
        }
    }

    &__full-price {
        text-decoration: line-through;
    }

    &__price,
    &__full-price {
        @media @sm {
            margin-top: 12px;
            margin-right: 9px;
        }
    }

    &__full-price + &__price {
        color: @red2;
    }
}

.count-change {
    position: absolute;
    right: 4px;
    top: 50%;
    padding: 8px;
    border: 1px @border2 solid;
    transform: translate(50%, -50%);
    display: flex;
    align-items: center;
    background: #fff;
    user-select: none;

    &__button {
        padding: 12px;
        cursor: pointer;
        .trs(opacity);

        &--disabled {
            opacity: 0.5;
            // pointer-events: none;
        }

        &:hover {
            color: @accent;
        }

        @media @sm {
            display: inline-block;
            width: 12px;
            height: 12px;
            padding: 2px;
            background: @border2;
            vertical-align: middle;
        }
    }

    &__value {
        margin: 0 -1px;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.size-change {
    user-select: none;
    position: absolute;
    top: 50%;
    left: calc(100% - 8px);
    transform: translate(-50%, -50%);
    padding: 8px;
    border: 1px @border2 solid;
    background: #fff;
    z-index: 1;

    &__item {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        & + & {
            margin-top: 8px;
        }

        &--active,
        &:hover {
            outline: 1px #000 solid;
        }
    }
}
</style>
